import type { EditSchemaDefinition } from "@/shared/components/CRUD/types";
import { CRUD } from "@/shared/components";
import {
  AssistantConversationsListQuery,
  AssistantConversationShowQuery,
} from "@/admin/entities/assistant";
import { AssistantConversationDetails } from "./AssistantConversationDetails";
import {
  useAssistantConversationsManagement,
  type AssistantConversationRow,
  AssistantConversationsSchemas,
} from "../model";

const getConversationTitle = () => "Диалог";

const editSchema: EditSchemaDefinition = {
  details: {
    label: "Диалог",
    type: "show" as const,
    getTitle: getConversationTitle,
    showComponent: AssistantConversationDetails,
    showQuery: AssistantConversationShowQuery,
  },
};

/**
 * Реестр диалогов зрителей с помощником. Только просмотр: диалоги
 * создаются и ведутся на витрине, здесь только аудит.
 */
export function AssistantConversations() {
  const { columns, mobileColumns, mapColumns, getTableData, texts } =
    useAssistantConversationsManagement();

  return (
    <CRUD<AssistantConversationRow>
      listQuery={AssistantConversationsListQuery}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={columns}
      filterSchema={AssistantConversationsSchemas.filterSchema}
      editSchema={editSchema}
      texts={texts}
      persistFilters
      hideCreateButton
      useMobileView
      mobileColumns={mobileColumns}
    />
  );
}
